import React, { useState, useEffect } from "react";
import { tourAssignmentService } from "../../services/tourAssignmentService";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Layout from "../layout/layout";
import Sidebar from "../profile-sidebar/profileSidebar";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import "./tour-guide-assign.css";

const TourGuideAssignments = () => {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(null);
  const { user } = useSelector((state) => state.auth);
  let userId = 0;
  if (user) {
    const decoded = jwtDecode(user);
    userId = decoded["sub"];
  } else {
    userId = 0;
  }

  const fetchAssignments = async () => {
    setLoading(true);
    try {
      const data = await tourAssignmentService.getTourGuideAssignments(userId);
      setAssignments(data.data || []);
    } catch (error) {
      console.error("Error fetching assignments:", error);
      toast.error("Không thể tải danh sách phân công.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, [userId]);

  const handleConfirm = async (assignmentId) => {
    setLoading(true);
    try {
      const response = await tourAssignmentService.confirmTourGuide(
        assignmentId
      );
      toast.success(response.data.message);
      await fetchAssignments();
    } catch (error) {
      console.error("Error confirming assignment:", error);
      toast.error(error.response?.data?.message || "Không thể xác nhận.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = (assignmentId) => {
    setSelectedAssignmentId(assignmentId);
    setShowCancelModal(true); // Hiển thị modal
  };

  const handleCancel = async () => {
    setLoading(true);
    try {
      const response = await tourAssignmentService.cancelTourGuide(
        selectedAssignmentId
      );
      toast.success(response.data.message);
      await fetchAssignments();
    } catch (error) {
      console.error("Error canceling assignment:", error);
      toast.error(error.response?.data?.message || "Không thể hủy.");
    } finally {
      setLoading(false);
      setShowCancelModal(false); // Ẩn modal
      setSelectedAssignmentId(null);
    }
  };

  const handleCancelClose = () => {
    setShowCancelModal(false); // Ẩn modal mà không thực hiện hành động
    setSelectedAssignmentId(null);
  };

  const renderStatus = (status) => {
    let dotStyle = {};
    switch (status.toLowerCase()) {
      case "pending":
        dotStyle = { backgroundColor: "yellow" };
        break;
      case "cancel":
        dotStyle = { backgroundColor: "red" };
        break;
      case "confirmed":
        dotStyle = { backgroundColor: "green" };
        break;
      default:
        dotStyle = { backgroundColor: "gray" };
    }

    return (
      <span style={{ display: "flex", alignItems: "center" }}>
        <span
          style={{
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            display: "inline-block",
            marginRight: "5px",
            ...dotStyle,
          }}
        ></span>
        {status}
      </span>
    );
  };

  return (
    <Layout>
      <div className="content">
        <div className="container">
          <div className="row">
            <Sidebar page="tour-guide-assignments" />
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header">
                  <h6>Danh sách phân công tour</h6>
                </div>
                <div className="card-body">
                  {loading ? (
                    <div className="d-flex justify-content-center align-items-center">
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                    </div>
                  ) : assignments && assignments.length === 0 ? (
                    <p>Không có phân công nào đang chờ xử lý.</p>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Tour</th>
                            <th>Số người tham gia</th>
                            <th>Ngày bắt đầu</th>
                            <th>Ngày kết thúc</th>
                            <th>Vai trò</th>
                            <th>Trạng thái</th>
                            <th>Hành động</th>
                          </tr>
                        </thead>
                        <tbody>
                          {assignments.map((assignment) => (
                            <tr key={assignment.id}>
                              <td>{assignment.tourName}</td>
                              <td>{assignment.currentParticipants}</td>
                              <td>
                                {moment(assignment.startDate).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>
                                {moment(assignment.endDate).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>{assignment.role}</td>
                              <td>{renderStatus(assignment.status)}</td>
                              <td>
                                {(assignment.status === "Pending" ||
                                  assignment.status === "Cancel") && (
                                  <button
                                    className="btn btn-success btn-sm "
                                    onClick={() => handleConfirm(assignment.id)}
                                    disabled={loading}
                                  >
                                    Confirm
                                  </button>
                                )}
                                {(assignment.status === "Pending" ||
                                  assignment.status === "Confirmed") && (
                                  <button
                                    className="btn btn-danger btn-sm me-2"
                                    onClick={() =>
                                      handleCancelClick(assignment.id)
                                    }
                                    disabled={loading}
                                  >
                                    Cancel
                                  </button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal xác nhận */}
      {showCancelModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Xác nhận hủy phân công</h5>
                <button
                  type="button"
                  className="btn btn-outline-info btn-sm"
                  onClick={handleCancelClose}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    fontSize: "16px",
                    padding: "0 8px",
                  }}
                >
                  X
                </button>
              </div>
              <div className="modal-body">
                <p>Bạn có chắc chắn muốn hủy phân công này không?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleCancelClose}>
                  Không
                </button>
                <button
                  className="btn btn-info"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  {loading ? "Đang xử lý..." : "Có"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default TourGuideAssignments;
